import React, { useState } from 'react';
import * as FeatherIcon from 'react-feather';

import { 
  Search, 
  FileText, 
  TrendingUp, 
  Bell, 
  Disc, 
  User, 
  ArrowRight,
  Users
} from 'lucide-react';

const GrowthIQTabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { id: 0, label: "Ask GrowthIQ", icon: <Search size={18} /> },
    { id: 1, label: "Project Mode", icon: <FileText size={18} /> },
    { id: 2, label: "Competitive Intel", icon: <TrendingUp size={18} /> },
    { id: 3, label: "Live Signals", icon: <Bell size={18} /> },
    { id: 4, label: "Opportunity Intel", icon: <Disc size={18} /> },
    { id: 5, label: "Customer Intel", icon: <User size={18} /> },
  ];

  return (
    <div className="explore_growth_wrapper">
      <div className="explore_growth_head_block text-center mb-5">
        <h1 className="explore_head">Explore GrowthIQ Capabilities</h1>
        <p className="explore_subhead">Click on each feature to learn more</p>
      </div>

      <div className="explore_tabs_block">
        <div className="container">
          {/* Tab Navigation */}
          <div className="top_explore_tabs">
            <ul className="top_list_ul">
              {tabs.map((tab) => (
                <li 
                  key={tab.id}
                  className={`top_list_li cursor-pointer ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <p className="top_list_block_img d-flex align-items-center gap-2 m-0">
                    <span className="top_list">{tab.label}</span>
                    {tab.icon}
                  </p>
                </li>
              ))}
            </ul>
          </div>

          {/* Tab Content Rendering */}
          <div className="tabs_content_block">
            {activeTab === 0 && <AskGrowthIQ />}
            {activeTab === 1 && <ProjectMode />}
            {activeTab === 2 && <CompetitiveIntel />}
            {activeTab === 3 && <LiveSignals />}
            {activeTab === 4 && <OpportunityIntel />}
            {activeTab === 5 && <CustomerIntel />}
          </div>
        </div>
      </div>
    </div>
  );
};

// Sub-components for each tab's content
const AskGrowthIQ = () => (
  <div className="ask_growthiq_tab_content">
    <div className="row">
      <div className="col-md-5">
        <div className="tab_left_block">
          <h5 className="main_head">Your Strategic Intelligence Copilot</h5>
          <h6 className="sub_head">Get expert-level answers to your most critical business questions-instantly.</h6>
          <ul className="tab_left_ul">
            {["Ask strategic questions in natural language", "Receive structured, source-backed intelligence", "Explore deeper with follow-up questions", "Export insights ready for presentations"].map((item, i) => (
              <li key={i} className="tab_left_list">
                <img src="/img/login/tick_icon.png" className='icon_tick' width="16" alt="tick" /> <span className="list_span">{item}</span>
              </li>
            ))}
          </ul>
          {/* <button className="btn btn-primary mt-3 d-flex align-items-center gap-2">
            Sign in to Try <ArrowRight size={16} />
          </button> */}
          <div className="sign_try_block">
          <a href="#login_form_section"> <button className="sign_try_btn btn">Sign In to Try <FeatherIcon.ArrowRight className='comp_icon ml-1' width={"16px"}/></button></a>
                        </div>
        </div>
      </div>
      <div className="col-md-7">
                      <div className="tab_right_block">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="tab_right_div">
                            <img src="/img/login/market_prior.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">Market <br/> Prioritization</h6>
                            <p className="tab_right_para">"Which market should we enter: cardiovascular or orthopedics?"</p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="tab_right_div">
                            <img src="/img/login/tam_analysis.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">TAM <br/> Analysis</h6>
                            <p className="tab_right_para">"What's the addressable market for our Al diagnostic platform in Europe?"</p>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="tab_right_div">
                            <img src="/img/login/comp_strat.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">Competitive Strategy</h6>
                            <p className="tab_right_para">"How should we position against our top 3 competitors?"</p>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
    </div>
  </div>
);

const ProjectMode = () => (
  <div className="project_mode_tab_content">
   <div className="row">
                    <div className="col-md-4">
                      <div className="tab_left_block">
                        <h5 className="main_head">Automated Strategy Consulting</h5>
                        <h6 className="sub_head">Generate boardroom-ready strategy documents in hours, not weeks.</h6>
                      </div>

                    </div>
                    <div className="col-md-8">
                      <div className="tab_right_block">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="tab_right_div">
                            <img src="/img/login/multiphase.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">Multi-Phase Research</h6>
                            <p className="tab_right_para">Automated workflows that mirror consulting methodology</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="tab_right_div">
                            <img src="/img/login/custom_framework.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">Custom Frameworks</h6>
                            <p className="tab_right_para">Apply your strategic frameworks or proven methodologies</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="tab_right_div">
                            <img src="/img/login/excutive_delivarables.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">Executive Deliverables</h6>
                            <p className="tab_right_para">Presentation- ready outputs with comprehensive analysis</p>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="tab_right_div">
                            <img src="/img/login/colla_refinement.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">Collaborative Refinement</h6>
                            <p className="tab_right_para">Iterate on findings and refine recommendation</p>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
  </div>
);

const LiveSignals = () => (

  <div className="live_signal_tab_content">
  <div className="container">
  <div className="row">
    <div className="col-md-12">
      <div className="tab_left_block">
        <h5 className="main_head">GROWTH IQ NEWS</h5>
      </div>

    </div>
    <div className="col-md-12">
      <div className="tab_right_block">
        <div className="row">
          <div className="col-md-3">
            <div className="tab_right_div">
            <h5 className="tab_right_head">LumaTech announces acquisition of NovaCore Systems in a multi‑year strategic deal</h5>
            <p className="tab_right_subhead_tag">Mergers & Acquisitions</p>


            <p className="companies_sub_para">Companies: LUMATECH</p>
            <p className="companies_sub_para">Region: Europe</p>
            <p className="companies_sub_para">Published: 12 Feb 2026</p>


            <img src="/img/login/fivestar.png" className="icon_tick" alt="tick icon"/>
            </div>
          </div>
          <div className="col-md-3">
            <div className="tab_right_div">
            <h5 className="tab_right_head">Synexa Technologies explores merger discussions with Veridian Analytics</h5>
            <p className="tab_right_subhead_tag">Corporate Strategy</p>


            <p className="companies_sub_para">Companies: SYNEXA TECHNOLOGIES</p>
            <p className="companies_sub_para">Region: North America</p>
            <p className="companies_sub_para">Published: 03 Feb 2026</p>


            <img src="/img/login/fivestar.png" className="icon_tick" alt="tick icon"/>
            </div>
          </div>
          <div className="col-md-3">
            <div className="tab_right_div">
            <h5 className="tab_right_head">Quantia Systems secures investment to expand cloud AI infrastructure</h5>
            <p className="tab_right_subhead_tag">Funding & Investment</p>


            <p className="companies_sub_para">Companies: QUANTIA SYSTEMS</p>
            <p className="companies_sub_para">Region: Asia Pacific</p>
            <p className="companies_sub_para">Published: 28 Jan 2026</p>


            <img src="/img/login/fivestar.png" className="icon_tick" alt="tick icon"/>
            </div>
          </div>
          <div className="col-md-3">
            <div className="tab_right_div">
            <h5 className="tab_right_head">EcoVerde Renewables announces new initiative for sustainable energy expansion</h5>
            <p className="tab_right_subhead_tag">Sustainability & Innovation</p>


            <p className="companies_sub_para">Companies: ECOVERDE RENEWABLES</p>
            <p className="companies_sub_para">Region: Middle East & Africa</p>
            <p className="companies_sub_para">Published: 15 Jan 2026</p>


            <img src="/img/login/three_star.png" className="icon_tick" alt="tick icon"/>
            </div>
          </div>
       
        
       
        </div>
      </div>

    </div>
  </div>
  </div>
</div>
);

// Helper Components
const Card = ({ title, desc }) => (
  <div className="col-md-4 mb-3">
    <div className="tab_right_div p-3 border rounded h-100">
      <h6 className="font-weight-bold">{title}</h6>
      <p className="small text-muted">{desc}</p>
    </div>
  </div>
);

const NewsCard = ({ title, tag, company, date }) => (
  <div className="col-md-3">
    <div className="p-3 border rounded">
      <h6 className="small font-weight-bold">{title}</h6>
      <span className="badge bg-light text-primary mb-2">{tag}</span>
      <p className="x-small m-0">Co: {company}</p>
      <p className="x-small text-muted">{date}</p>
    </div>
  </div>
);

// Placeholder components for other tabs following the same pattern
const CompetitiveIntel = () => <div>
  

  <div className="comp_intel_tab_content">
                  <div className="container">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="tab_left_block">
                        <h5 className="main_head">Know Your <br/> Market Position</h5>
                        <h6 className="sub_head">Deep competitor analysis updated continuously, not annually.</h6>
                      </div>

                    </div>
                    <div className="col-md-8">
                      <div className="tab_right_block">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="tab_right_div">
                            <img src="/img/login/comp_profiles.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">Competitor Profiles</h6>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="tab_right_div">
                            <img src="/img/login/revenue_teardowns.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">Revenue Teardowns</h6>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="tab_right_div">
                            <img src="/img/login/strat_becnmarkings.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">Strategic Benchmarking</h6>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="tab_right_div">
                            <img src="/img/login/swot.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">SWOT + Battle Cards</h6>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="tab_right_div">
                            <img src="/img/login/strat_insights.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">Strategy Insights</h6>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="tab_right_div">
                            <img src="/img/login/continous_updates.png" className="icon_tick" alt="tick icon"/>
                            <h6 className="tab_right_subhead">Continuous Updates</h6>
                            </div>
                          </div>
                       
                        </div>
                      </div>

                    </div>
                  </div>
                  </div>
                </div>
</div>;
const OpportunityIntel = () => <div>
     <div className="opp_tab_content">
                  <div className="container">
                  <div className="row">
                  
                    <div className="col-md-12">
                    <div class="table-content">

                    <table class="table_custom_signal">
  <thead>
    <tr>
      <th scope="col" class="col-opp">Opportunity</th>
      <th scope="col" class="col-opp" style={{maxWidth:"110px"}}>Signal</th>
      <th scope="col" class="col-opp" style={{minWidth:"110px"}}>My Offerings</th>
      <th scope="col" class="col-opp">Contacts</th>
      <th scope="col" class="col-opp">Relevance</th>
      <th scope="col" class="col-opp" style={{minWidth:"140px"}}>Documents</th>
      <th scope="col" class="col-opp" style={{minWidth:"240px"}}>Actions</th>

    </tr>
  </thead>
  <tbody>
    <tr className="tr_block">
      <td scope="row"> 
      <div class="col-opp">
          <strong>Strategic Roadmap Development for 2027-2029 Growth Acceleration</strong>
        </div>
        </td>
      <td>   <div class="col-sig">
          <span class="badge badge-green-outline">Market <br/> Expansion Insight</span>
        </div></td>
      <td> <div class="col-off">
          <span class="badge-count">+2</span>
        </div></td>
      <td>
      <div class="col-con">
          <div class="contact-info">
            <span><img src="/img/login/three_icon.png" class="icon_number mr-2" width="16" alt="icon"/>9</span>
          </div>
        </div>
      </td>
      <td>
      <div class="col-rel">
          <span class="badge badge-green-solid">High</span>
        </div>
      </td>
      <td>
      <div class="col-doc">
          <div class="doc-group">
            <button class="btn-doc">
            <img src="/img/login/battle_card.webp" className="icon_tick" width="18" alt="tick icon"/>
              Battle Card
            </button>
            <span class="badge-count">+1</span>
          </div>
        </div>
      </td>
      <td>
      <div class="col-act">
          <div class="action-group">
            <button class="btn-outline">Move To Win</button>
            <button class="btn-outline">Auto Nurture</button>
          </div>
        </div>
      </td>
    
    </tr>
    <tr className="tr_block">
      <td>
      <div class="col-opp">
          <strong>AI Adoption Blueprint for Cross-Industry Transformation</strong>
        </div>
      </td>
      <td>
      <div class="col-sig">
          <span class="badge badge-green-outline">Digital <br/> Innovation Brief</span>
        </div>
      </td>
      <td>
      <div class="col-off">
          <span class="badge-count">+3</span>
        </div>
      </td>
      <td>
      <div class="col-con">
          <div class="contact-info">
          <span><img src="/img/login/three_icon.png" class="icon_number mr-2" width="16" alt="icon"/>11</span>
          </div>
        </div>
      </td>
      <td>
      <div class="col-rel">
          <span class="badge badge-orange-solid">Medium</span>
        </div>
      </td>
      <td>
      <div class="col-doc">
          <div class="doc-group">
            <button class="btn-doc">
            <img src="/img/login/battle_card.webp" className="icon_tick" width="18" alt="tick icon"/>
              Battle Card
            </button>
            <span class="badge-count">+1</span>
          </div>
        </div>
      </td>
      <td>
      <div class="col-act">
          <div class="action-group">
            <button class="btn-outline">Move To Win</button>
            <button class="btn-outline">Auto Nurture</button>
          </div>
        </div>
      </td>


    </tr>

    <tr className="tr_block">
      <td>
      <div class="col-opp">
          <strong>Global Sustainability Benchmarking for Net-Zero Alignment</strong>
        </div>
      </td>
      <td>
      <div class="col-sig">
          <span class="badge badge-green-outline">ESG Priority Alert</span>
        </div>
      </td>
      <td>
      <div class="col-off">
          <span class="badge-count">+1</span>
        </div>
      </td>
      <td>
      <div class="col-con">
          <div class="contact-info">
          <span><img src="/img/login/three_icon.png" class="icon_number mr-2" width="16" alt="icon"/>10</span>
          </div>
        </div>
      </td>
      <td>
      <div class="col-rel">
          <span class="badge badge-orange-solid">Medium</span>
        </div>
      </td>
      <td>
      <div class="col-doc">
          <div class="doc-group">
            <button class="btn-doc">
            <img src="/img/login/battle_card.webp" className="icon_tick" width="18" alt="tick icon"/>
              Battle Card
            </button>
            <span class="badge-count">+1</span>
          </div>
        </div>
      </td>
      <td>
      <div class="col-act">
          <div class="action-group">
            <button class="btn-outline">Move To Win</button>
            <button class="btn-outline">Auto Nurture</button>
          </div>
        </div>
      </td>
    </tr>

    <tr className="tr_block">
      <td>
      <div class="col-opp">
          <strong>Future Mobility Ecosystem Analysis for Market Positioning</strong>
        </div>
      </td>
            <td>
            <div class="col-sig">
          <span class="badge badge-green-outline">Mobility <br/> Insight Trigger</span>
        </div>
            </td>
            <td>
            <div class="col-off">
          <span class="badge-count">+2</span>
        </div>
            </td>
            <td>
            <div class="col-con">
          <div class="contact-info">
          <span><img src="/img/login/three_icon.png" class="icon_number mr-2" width="16" alt="icon"/>12</span>
          </div>
        </div>
            </td>
      <td>
      <div class="col-rel">
          <span class="badge badge-green-solid">High</span>
        </div>
      </td>
      <td>
      <div class="col-doc">
          <div class="doc-group">
            <button class="btn-doc">
            <img src="/img/login/battle_card.webp" className="icon_tick" width="18" alt="tick icon"/>
              Battle Card
            </button>
            <span class="badge-count">+1</span>
          </div>
        </div>
      </td>
      <td>
      <div class="col-act">
          <div class="action-group">
            <button class="btn-outline">Move To Win</button>
            <button class="btn-outline">Auto Nurture</button>
          </div>
        </div>
      </td>

    </tr>
  </tbody>
</table>

    </div>

                    </div>
                  </div>
                  </div>
                </div>
</div>;
const CustomerIntel = () => <div>
      <div className="custom_intel_tab_content">
                  <div className="container">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="tab_left_block">
                        <h5 className="main_head">Available in Full Platform</h5>
                        <h6 className="sub_head">Sign in to access this feature and explore 
the complete GrowthIQ platform</h6>
<div className="sign_try_block">
<a href="#login_form_section"> <button className="sign_try_btn btn">Sign In Now <FeatherIcon.ArrowRight className='comp_icon ml-1' width={"16px"}/></button></a>
                        </div>
                      </div>
                    

                    </div>
                    <div className="col-md-6">
                      <div className="tab_right_block">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="tab_right_div">
                            <img src="/img/login/customer_intel_right.png" className="icon_tick" alt="tick icon"/>
                            </div>
                          </div>
                     
                        </div>
                      </div>

                    </div>
                  </div>
                  </div>
                </div>
</div>;

export default GrowthIQTabs;